import React, { useState, createContext, useEffect } from "react";
const AppContext = createContext();
const { Provider } = AppContext;

const AppProvider = ({ children }) => {
  const [formValue, setFormValue] = useState({
    projectName: "",
    projectType: 0,
    ownerType: 0,
    ownerFirstName: "",
    ownerLastName: "",
    ownerOrganization: "",
    ownerRole: "",
    ownerCity: "",
    ownerPhone1: "",
    ownerPhone2: "",
    ownerMail: "",
    projectSummery: "",
    projectDescription: "",
    projectStatusType: 0,
    projectTimeEstimate: "",
    projectBeginDate: "",
    projectTeamType: 0,
    projectTeamDescription: "",
    projectSickInfluence: 0,
    projectGovInfluence: 0,
    projectMoneyInfluence: 0,
    projectFile1: null,
    projectFile2: null,
    projectFile3: null,
    projectLink1: "",
    projectLink2: "",
    projectLink3: "",
    projectContestAgree: false,
    projectTimeAgree: false,
  });
  const [popupText, setPopupText] = useState("");
  const [popupSecondaryText, setPopupSecondaryText] = useState(
    ""
  );
  const [popupVisible, setPopupVisible] = useState(false);
  const [formActive, setFormActive] = useState(true);



  
  useEffect(() => {
    let finishDate = new Date('2020/10/12 00:01:00');
    if(finishDate <= new Date()){
      setFormActive(false);
    }
  }, [])

  useEffect(() => {
    if(!formActive){
      setPopupVisible(false);
      setPopupText("הפעילות הסתיימה");
      setPopupSecondaryText("");
    }
  }, [formActive])



  const state = {
    formValue,
    popupVisible,
    popupText,
    popupSecondaryText,
    formActive
  };
  useEffect(() => {
    window.state = formValue
  });
  useEffect(() => {
    if (!popupVisible) {
      setPopupText("");
      setPopupSecondaryText("")

    }
  }, [popupVisible])
  const actions = {
    setFormValue,
    setPopupVisible,
    setPopupText,
    setPopupSecondaryText,
    setFormActive
  };

  return <Provider value={{ ...state, ...actions }}>{children}</Provider>;
};

export { AppContext, AppProvider };
